<template>
  <div class="activity-chips-wrapper">
    <div
      class="flex items-center bg-background-light --shadow__bottom --border-right --text-sm text-weight-medium"
      style="position: absolute; left: 0; top: 0; height: 100%; z-index: 10;"
      :class="{ 'q-px-lg': windowWidth > 769, 'q-px-md': windowWidth <= 769 }"
    >
      <span class="live-dot"></span>
      Live Market
    </div>
    <div class="activity-chips-scroll">
      <template v-if="loading">
        <div
          v-for="i in 100"
          :key="'skeleton_' + i"
          class="flex items-center --text-sm"
        >
          <q-skeleton type="text" width="160px" />
          <q-separator vertical class="q-mx-md" />
        </div>
      </template>
      <template v-else>
        <div
          v-for="vehicle in displayVehicles"
          :key="vehicle.year + '_' + vehicle.make_id + '_' + vehicle.model_id"
          @click="
            () => {
              searchByModel(vehicle.year, vehicle.make_id, vehicle.model_id);
            }
          "
          clickable
          class="flex items-center --text-sm text-text-light cursor-pointer --hover-lighten-brighter"
        >
          <div class="text-weight-medium">
            {{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }}
          </div>
          <div
            class="flex items-center q-ml-xs q-mr-sm"
            :class="
              vehicle.total_vehicles_today_percent_change >= 0
                ? 'text-positive'
                : 'text-negative'
            "
          >
            <q-icon
              :name="
                vehicle.total_vehicles_today_percent_change >= 0
                  ? 'sym_r_trending_up'
                  : 'sym_r_trending_down'
              "
              size="17px"
              style="margin-top: -2px; margin-right: 2px"
            />
            {{
              Math.abs(vehicle.total_vehicles_today_percent_change).toFixed(1)
            }}%
          </div>
          <div class="text-text-lighter --text-sm" style="margin-bottom: -2px">
            Avg. ${{ formatNumber(vehicle.avg_price, true) }}
          </div>
          <q-separator vertical class="q-mx-md" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LiveMarketTicker",
  data() {
    return {
      vehicles: [],
      loading: true
    };
  },
  computed: {
    // Duplicate the array for seamless scrolling
    displayVehicles() {
      return [...this.vehicles, ...this.vehicles];
    }
  },
  mounted() {
    this.fetchVehicles();
  },
  methods: {
    async fetchVehicles() {
      try {
        this.loading = true;
        const { data } = await axios.get(
          "https://api-v2.jumpfeed.com/network/publisher/products/vehicles/most-listed-market-models",
          {
            params: {
              limit: 100
            }
          }
        );

        let vehicles = data.data;
        vehicles = [...vehicles].sort(() => Math.random() - 0.5);
        vehicles.forEach((vehicle, i) => {
          if (vehicle.total_vehicles_today_percent_change.toFixed(1) == 0) {
            vehicles[i].total_vehicles_today_percent_change = 0.1;
          }
        });

        this.vehicles = vehicles;
      }
      catch (error) {
        console.error("Failed to fetch vehicle data:", error);
      }
      finally {
        this.loading = false;
      }
    },
    searchByModel(year, makeId, modelId) {
      this.$store.commit("search/SET_SEARCH_FILTERS", [
        { year: { gte: year, lte: year } },
        { make_id: { in: [makeId] } },
        { model_id: { in: [modelId] } }
      ]);
      this.$router.push({ name: "search" });
    }
  }
};
</script>

<style scoped lang="scss">
.activity-chips-wrapper {
  overflow: hidden;
  width: 100%;
  padding: 8px 0px 6px;
  background: color(background, light);
  box-shadow: $shadow-bottom;
}

.activity-chips-scroll {
  display: flex;
  animation: scroll-chips 720s linear infinite;
  width: max-content;

  @include screen-sm {
    animation: scroll-chips 580s linear infinite;
  }

  &:hover {
    animation-play-state: paused;
  }
}

@keyframes scroll-chips {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.live-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #ef4444;
  border-radius: 50%;
  margin-right: 8px;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
    filter: brightness(1.08);
  }
  50% {
    opacity: 0.4;
    transform: scale(1.1);
  }
}
</style>
